
/**
 * Custom component for Bimini food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.2
 * @copyright  Copyright (C) 2025-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 *    2025-02-10 (1.0.0) (jhoward)
 *      - <thanksgivingFoodItem> copied to <valentinesDayFoodItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <valentinesDayFoodItem>.
 *
 * 2026-02-06 (1.0.2) (jhoward)
 *   - Adjust .valentines-day_food_item--container .menu--tag top position from 1em to -1.5em for improved layout.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'valentines-day-food-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-inline'
    }
  },
})
